import useConfigStore from "../stores/useConfigStore";

export const getPricingPolicies = () => useConfigStore.getState().pricingPolicies || [];
